import { css } from 'styled-components';

const flex = css`
    .flexGrow {
        flex-grow: 1;
    }
`;

export default flex;
